import Localization from "aldoo-ra/Localization"
import Menu from "aldoo-ra/Menu"
import { useState, useEffect } from "react"
import { GlobeAltIcon } from "@heroicons/react/24/outline"

export default function SiteLanguageSelector({
  showMenuMode = "hover",
  menuPosition = "bottom",
  menuAlign = "right",
}) {
  const { currentLanguage, setLanguage, languages } = Localization()
  const [isClient, setIsClient] = useState(false)
  const [isTouchDevice, setIsTouchDevice] = useState(false)

  useEffect(() => {
    setIsClient(true)
    setIsTouchDevice("ontouchstart" in window || navigator.maxTouchPoints > 0)
  }, [])

  const effectiveShowMenuMode = isTouchDevice ? "click" : showMenuMode

  const menu = isClient
    ? {
        label: currentLanguage?.toUpperCase(),
        items:
          languages?.map?.((language) => ({
            options: {
              action: () => setLanguage(language.code),
            },
            label: (language.displayName || language.code.toUpperCase()).replace(/\s*\(.*?\)/g, "").trim(),
          })),
      }
    : { label: "", items: [] }

  if (!isClient) return <div className="w-6 h-6" />

  return (
    <div>
      <Menu
        menuData={menu}
        hideOnItemClick
        renderAs="vlist.menu"
        maxItemsPerColumn={10}
        menuAlign={menuAlign}
        showMenuMode={effectiveShowMenuMode}
        menuPosition={menuPosition}
        styleOverrides={{
          submenu:
            "absolute top-full mt-2 py-1.5 bg-paper shadow-lg border border-bordered rounded-2xl z-50 min-w-[120px] overflow-hidden",
          menu: "list-none p-0 m-0 w-full",
          menu_item: "flex flex-col p-0 m-0 cursor-pointer w-full",
          menu_column: "w-full",
          root_item: "flex items-center cursor-pointer",
        }}
        menuItemRender={(item) => (
          <div className="px-4 py-3 text-sm text-text hover:bg-primary/10 hover:text-primary cursor-pointer w-full text-left transition">
            {item.label}
          </div>
        )}
        rootItemRender={() => (
          <div className="h-10 flex items-center gap-1.5 text-text hover:text-primary rounded-lg px-3 transition text-sm font-medium cursor-pointer">
            <GlobeAltIcon className="w-4 h-4 flex-shrink-0" />
            <span>{currentLanguage?.toUpperCase()}</span>
          </div>
        )}
      />
    </div>
  )
}
